import { Action } from "./enum";
import BaseReducer from "shared/types/baseReducer";
import ApiPurchaseOrder from "shared/model/ApiPurchaseOrder";
import { ActionType, DispatchInterface, State } from "./types";

export default class Reducer extends BaseReducer<ActionType> implements DispatchInterface {
  static getInitialState(): State {
    return {
      stepNo: 1,
      purchaseOrder: undefined,
      quantityPurchased: undefined,
      selectedBulkTicketFormId: ""
    };
  }

  static reducer(state: State, action: ActionType): State {
    switch (action.type) {
      case Action.UPDATE_STEP:
        return { ...state, stepNo: action.payload };
      case Action.UPDATE_PURCHASE_ORDER:
        return { ...state, purchaseOrder: action.payload };
      case Action.UPDATE_QUANTITY_PURCHASED:
        return { ...state, quantityPurchased: action.payload };
      case Action.UPDATE_SELECTED_BULK_TICKET_FORM_ID:
        return { ...state, selectedBulkTicketFormId: action.payload };
      default:
        return state;
    }
  }

  public updateStep(payload: number): void {
    return this.dispatch({ type: Action.UPDATE_STEP, payload });
  }

  public updateQuantityPurchased(payload: number): void {
    return this.dispatch({ type: Action.UPDATE_QUANTITY_PURCHASED, payload });
  }

  public updatePurchaseOrder(payload?: ApiPurchaseOrder): void {
    return this.dispatch({ type: Action.UPDATE_PURCHASE_ORDER, payload });
  }

  public updateSelectedBulkTicketFormId(payload: string): void {
    return this.dispatch({ type: Action.UPDATE_SELECTED_BULK_TICKET_FORM_ID, payload });
  }
}
